<template>
    <div class="modal-overlay active"  @click="closeDialog()"></div>
    <div class="modal">
        <div class="modal__header">
            <h2 class="headline-s">{{ modalHeader }}</h2>
            <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
        </div>
        <div class="modal__body">
            <div class="modal__body--content-wrapper">
                <p>Are you sure you want to delete this collect account?</p>
            </div>
            <RothcoCta ctaType="button" class="secondary" @click="closeDialog()">
                Cancel
            </RothcoCta>
            <RothcoCta ctaType="button" class="primary" id="submitButton" @click="submit">
                Delete
            </RothcoCta>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import RothcoCta from "@/components/RothcoCta.vue";
    import NProgress from "nprogress";
    import { computed, inject } from "vue";
    import { useFetch } from "@/helpers/composables/useFetch";
    import CloseIcon from "@icons/closeIcon.svg";
    const dialogRef = inject('dialogRef');
    const closeDialog = () => {
        dialogRef?.value?.close();
    }

    const modalHeader = computed(()=>{
        return dialogRef?.value?.options?.header ?? 'Delete List Collect Account';
    })

    const submit = function () {
        useFetch(
            route(
                "endpoint.companycollectaccount.destroy",
                dialogRef.value.data.collect_account_id
            ),
            {
                beforeFetch: (ctx) => {
                    NProgress.start();
                    ctx.options.headers = {
                        ...ctx.options.headers,
                        'Accept': 'application/json',
                    }
                    return ctx;
                },
                afterFetch: async (ctx) => {
                    if (NProgress.isStarted()) {
                        NProgress.done();
                    }
                    if(dialogRef?.value?.data?.afterSubmit){
                        dialogRef.value.data.afterSubmit()
                    }
                    dialogRef?.value?.close();
                    return ctx;
                }
            }
        )
            .delete()
            .json();
    };
</script>
